module.exports = __webpack_public_path__ + "img/logo_blanc.4b93c4b4.png";